export default __webpack_public_path__ + "static/media/5076.39edd6e0.png";